module.exports = __webpack_public_path__ + "img/circle_marker.ab6cba76.svg";